module.exports = __webpack_public_path__ + "media/images/success/googleplay_short-58daf7c9800ad0b1dd8a2d03c3ef0ee1.png";